import styled from 'styled-components/macro';

export const Container = styled.div`
  max-width: 1264px;
  width: 100%;
  margin: 0 36px;
  padding: 24px 0;
`;
